import React, { PropsWithChildren } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { BodyProps } from '@swyftx/aviary/atoms/Typography/Body/Body.styles';

import { cn } from '@shared/utils/lib/ui';

import { EnhancedTooltip } from '../EnhancedTooltip/EnhancedTooltip';

type Props = {
  title: string;
  underline?: BodyProps['underline'];
  tooltip?: string;
  name?: string;
  className?: string;
};

const ReviewItem: React.FC<PropsWithChildren<Props>> = ({ title, name, underline, tooltip, children, className }) => (
  <FlexLayout className={cn('w-full', className)} alignItems='start' justifyContent='space-between' spacing={8}>
    <EnhancedTooltip name={name || title} title={tooltip} side='left'>
      <Body
        color='secondary'
        underline={underline}
        className={cn(underline !== undefined ? 'cursor-pointer ' : '', 'whitespace-nowrap')}
      >
        {title}
      </Body>
    </EnhancedTooltip>
    {children}
  </FlexLayout>
);

export { ReviewItem };
